import { useParams, useRouter } from '@/lib/navigation';
import { useEffect } from 'react';
import { Spinner } from '@/components/ui/shadcn-io/spinner';
import { useTrip } from '@/hooks/trips/useTrip';

export function CityRedirectPage() {
  const params = useParams();
  const router = useRouter();
  const tripId = params.id as string;

  const { isLoading: tripLoading } = useTrip(tripId);

  useEffect(() => {
    if (!tripLoading) {
      // Always redirect to create new city for now
      // TODO: Replace with cities list when implemented
      router.replace(`/trips/${tripId}/cities/new`);
    }
  }, [tripLoading, router, tripId]);

  // Show loading while determining where to redirect
  return (
    <div className="flex min-h-screen items-center justify-center bg-white">
      <Spinner variant="circle" />
    </div>
  );
}
